const tabId = () => {
  const tabId = sessionStorage.tabID
    ? sessionStorage.tabID
    : (sessionStorage.tabID = Math.floor(Date.now() * Math.random()).toString(36));

  return tabId;
};

export default tabId;
